module.exports = __webpack_public_path__ + "media/images/emoticons/pen-580519478b8490657faae6d73754f137.gif";